// ControlTextAreaInputFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import TextAreaInputControlView  from 'common-inputs/TextAreaInputControlView.js';


//=============================================================================
//
// Creates a text area input control, given a factoryService
// parameter key and a layout position. The factory key defines the
// control appearance through its template. It defines the initial rectangle
// of the control via a width and height from the factory parameter.
//
// Brad Trebilcock, January 17, 2016
//
//=============================================================================
class ControlTextAreaInputFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.backgroundColor = '~inputBgColor';
		attributes.inlineEditable = true;
		attributes.horizontalScroll = '';
		attributes.verticalScroll = '';
        attributes.resizePadding = 12;
		attributes.minWidth = 10;
		attributes.align = 'left';
        attributes.lowestHeight = 20;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new TextAreaInputControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlTextAreaInputFactory = new ControlTextAreaInputFactory();

export default controlTextAreaInputFactory;